import { jsx as t, Fragment as y, jsxs as L } from "react/jsx-runtime";
import { useState as b, useMemo as A, useCallback as I, useLayoutEffect as N } from "react";
import a from "./styles.module.less.js";
import C from "./logo.webp.js";
import { usePathname as E } from "../../../utils/use-pathname.js";
import { AccountLink as $ } from "./account-link/index.js";
import { FLOATING_CONTAINER_ID as m } from "./index.js";
import { areasOfLawData as D } from "../../../constants.js";
import { convertToKebabCase as M } from "../../../utils/case-conversion.js";
import { DropdownMenuItemDesktop as S } from "./dropdown-menu-item/index.js";
import { MenuItem as k } from "./menu-item/index.js";
import { ForLawyersMenuButtonDesktop as R } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemDesktop as T } from "./get-help-menu-item/index.js";
import { MenuChatButtonDesktop as P } from "./chat-button/index.js";
import { getRoute as B, RouteType as H } from "../../../utils/get-route.js";
const F = "/help", Z = (s) => {
  const {
    getTranslation: r,
    language: e,
    isLawyerSupported: d = !1,
    useWill: f = !1,
    lmpEnabled: p = !1,
    hideLinks: v = !1
  } = s, o = E(), [i, h] = b(!1), c = A(() => {
    const n = D[e];
    if (n)
      return [
        ...n.map((u) => ({
          ...u,
          path: `/${e}/topics/${M(u.title)}`
        }))
      ];
  }, [e]), l = I(
    (n) => {
      switch (n) {
        case "/chat":
          return o === "/chat";
        case "/about":
          return o === `/${e}/about`;
        case "/about/company":
          return o === `/${e}/about/company`;
        case "/help":
          return o === F;
        case "/find":
          return o.endsWith(
            "/find"
            /* BROWSE_LAWYERS */
          );
        case "/topics":
          return o === `/${e}/topics`;
        case "/account":
          return o === "/account";
        case "/for-lawyers/legal-network":
          return o === `/${e}/for-lawyers/legal-network`;
        case "/make-a-will":
          return o === B(H.WILL_INFO);
        default:
          return !1;
      }
    },
    [o, c, e]
  );
  return N(() => {
    const n = () => {
      var w, g;
      (window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0) > 80 ? ((w = document.getElementById(m)) == null || w.classList.add(a.shrink), h(!0)) : ((g = document.getElementById(m)) == null || g.classList.remove(a.shrink), h(!1));
    };
    return window.addEventListener("scroll", n), document.body.addEventListener("scroll", n), n(), () => {
      window.removeEventListener("scroll", n), document.body.removeEventListener("scroll", n);
    };
  }, []), /* @__PURE__ */ t(y, { children: /* @__PURE__ */ t("div", { className: a.floatingContainer, id: m, children: /* @__PURE__ */ L("div", { className: a.menuContentContainer, children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: e ? `/${e}` : "/",
        className: a.logoContainer,
        children: /* @__PURE__ */ t(
          "img",
          {
            src: C,
            alt: "LawConnect Logo",
            width: 0,
            height: 20,
            className: a.logo
          }
        )
      }
    ),
    !v && /* @__PURE__ */ L("div", { className: a.menuLinksContainer, children: [
      d ? /* @__PURE__ */ t(
        T,
        {
          language: e,
          titleLabel: r("pages.get-help"),
          getTranslation: r,
          hasShrunk: i,
          isLawyerSupported: !0,
          onRequestLawyer: s.onRequestLawyer,
          isActive: l(
            "/help"
            /* HELP */
          )
        }
      ) : /* @__PURE__ */ t(
        P,
        {
          getTranslation: r,
          isScrolledHeader: i
        }
      ),
      d ? null : /* @__PURE__ */ t("div", { className: a.spacer }),
      p ? /* @__PURE__ */ t(
        k,
        {
          label: "Browse lawyers",
          path: e ? `/${e}/find` : "/find",
          hasShrunk: i,
          isActive: l(
            "/find"
            /* BROWSE_LAWYERS */
          )
        }
      ) : null,
      c ? /* @__PURE__ */ t(
        S,
        {
          language: e,
          items: c,
          titleLabel: r("pages.legal-topics"),
          hasShrunk: i,
          link: `/${e}/topics`,
          classNames: {
            container: a.subMenuContainer,
            itemRow: a.offsetDropdownItemRow
          },
          isActive: l(
            "/topics"
            /* KNOWLEDGE_BASE */
          )
        }
      ) : null,
      p ? null : /* @__PURE__ */ t(
        k,
        {
          label: r("pages.about"),
          path: `/${e}/about/company`,
          hasShrunk: i,
          isActive: l(
            "/about/company"
            /* ABOUT_COMPANY */
          )
        }
      ),
      /* @__PURE__ */ t(
        R,
        {
          language: e,
          getTranslation: r,
          useWill: f,
          isScrolledHeader: i,
          isActive: l(
            f ? "/make-a-will" : "/for-lawyers/legal-network"
            /* FOR_LAWYERS */
          ),
          environment: s.environment
        }
      ),
      /* @__PURE__ */ t(
        $,
        {
          isScrolledHeader: i,
          isActive: l(
            "/account"
            /* ACCOUNT */
          ),
          isAuthenticated: s.isAuthenticated,
          userImage: s.userImage,
          openAuthModal: s.openAuthModal,
          logout: s.logout,
          hasNotifications: s.hasNotifications,
          language: e,
          getTranslation: r
        }
      )
    ] })
  ] }) }) });
};
export {
  Z as DesktopMenu
};
